var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 456,
    viewBox: "0 0 456 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.757 448.004C215.758 458.476 235.021 458.654 254.547 448.586L227.883 226.704L196.757 448.004Z",
    fill: "#812456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6306 406.835C99.9448 425.463 116.633 435.306 138.672 436.408L226.359 230.834L88.6306 406.835Z",
    fill: "#812456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.148 409.6C351.461 427.995 334.578 437.501 312.521 438.158L228.991 230.861L363.148 409.6Z",
    fill: "#812456"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.185 7.41705C220.393 -2.67059 239.656 -2.46047 258.975 7.99903L227.85 229.298L201.185 7.41705Z",
    fill: "#812456"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.2529 46.4028C103.94 28.0072 120.823 18.5017 142.879 17.8442L226.41 225.142L92.2529 46.4028Z",
    fill: "#812456"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.768 49.1672C355.454 30.54 338.765 20.6964 316.727 19.5948L229.04 225.168L366.768 49.1672Z",
    fill: "#812456"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41571 254.222C-2.67011 235.011 -2.46003 215.744 7.9976 196.422L229.257 227.553L7.41571 254.222Z",
    fill: "#812456"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4062 363.192C28.0139 351.503 18.5101 334.616 17.8527 312.556L225.113 229.011L46.4062 363.192Z",
    fill: "#812456"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1701 88.5938C30.5462 99.9101 20.7044 116.602 19.603 138.644L225.139 226.347L49.1701 88.5938Z",
    fill: "#812456"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.005 258.661C458.476 239.657 458.653 220.39 448.587 200.861L226.745 227.53L448.005 258.661Z",
    fill: "#812456"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M406.828 366.823C425.452 355.506 435.294 338.815 436.396 316.772L230.859 229.07L406.828 366.823Z",
    fill: "#812456"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.592 92.2285C427.985 103.918 437.488 120.804 438.146 142.864L230.885 226.41L409.592 92.2285Z",
    fill: "#812456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.a60edae58ecf0476ef80782a968222fa.svg";
export { ForwardRef as ReactComponent };